import Vue from 'vue'
import {CONFIG} from './config.js'
import accents from 'remove-accents'

const Shift = Vue.component('shift', {
    props: ['shift', 'searchTerm'],
    template: '#shift',
    data: function() {
        return {
            showConfirm: false
        }
    },
    methods: {
        goToDetail: function() {
            this.$router.push({path: "/detail/" + this.shiftId})
        },
        shiftApprove: function() {
            this.updateShiftState('APPROVED');
        },
        shiftAbsence: function() {
            this.updateShiftState('ABSENCE');
        },
        shiftUnapprove: function() {
            this.updateShiftState('UNAPPROVED');
        },
        updateShiftState: function(status) {
            var self = this;

            this.$updateShiftState(this.shiftId, this.shiftVersion, status,
                function (r) {
                    self.$store.commit('updateShiftById', { id: self.shift.ord_shift_id, data: r.data[0] });
                    self.$ebus.$emit("msg:new", {type: "message-success", data: {text: self.$t("message.updated")}})
                });
        },
        parseShiftDateTime: function (time) {
            return this.$moment(this.shift.shift_date + " " + time, "YYYY-MM-DD HH:mm:ss");
        }
    },
    computed: {
        shiftId: function() {
            return this.shift.ord_shift_id;
        },
        shiftVersion: function() {
            return this.shift.objversion;
        },
        shiftFrom: function() {
            return this.parseShiftDateTime(this.shift.shift_time_from);
        },
        shiftTo: function() {
            return this.parseShiftDateTime(this.shift.shift_time_until);
        },
        show: function() {
            if (this.searchTerm == null || accents.remove(this.shift.person_name.toLowerCase()).search(accents.remove(this.searchTerm.toLowerCase())) > -1) {
                return true;
            }
            return false;
        }
    }
})

export default Shift;